// The way back to a page's parent: a left chevron and the parent's name. Installed
// on a phone, Crew has no browser Back, so it's 44px tall there; the negative
// margins keep it the height of a line of text in the layout.
import { Link } from "@crew/ui/components/link";
import { cn } from "@crew/ui/lib/utils";
import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";

export function BackLink({
  href,
  children,
  className,
}: {
  href: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Link
      href={href}
      data-slot="back-link"
      className={cn(
        "-my-3 -ml-2 flex h-11 w-fit items-center gap-1 rounded-md pr-3 pl-1 text-meta font-medium text-muted-foreground outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring md:-my-1.5 md:h-8",
        className,
      )}
    >
      <ChevronLeft aria-hidden className="size-4 shrink-0" />
      {children}
    </Link>
  );
}
